<div class="app-toast-content" [ngClass]="'app-toast-content-' + data.type">
    <!-- <div class="app-toast-icon">
        {{ getIcon() }}
    </div> -->

    <div class="app-toast-text" matSnackBarLabel>
        <div class="app-toast-header">
            {{ data.header }}
        </div>

        <div class="app-toast-message">
            @for (sentence of messageLines; track $index) {
            <div>
                {{ sentence }}
            </div>
            }
        </div>
    </div>

    <div matSnackBarActions>
        <button mat-button matSnackBarAction class="app-toast-close" type="button" (click)="snackBarRef.dismiss()">
            X
        </button>
    </div>
</div>